import type { SupportedExperiment } from '../types/experiment.types';

/**
 * Master list of supported experiments for the fragment. Currently empty.
 */
export const supportedExperiments: SupportedExperiment[] = [];

/**
 * Master list of supported feature gates for the fragment. Currently empty.
 */
export const supportedFeatureGates: string[] = [];
